import {AxiosResponse} from "axios";
import {Bindings} from "data/constants/bindings";
import type {IApiResponse, IHttpClientService} from "data/services/http";
import {IShareImage} from "data/stores/share/share.store";
import {inject, injectable} from "inversify";

export interface ILineup {
	golfers: number[];
	value: string;
}

export interface IPickResponse {
	id: number | null;
	name: string | null;
	points: number | null;
	margin: number;
	longestDriveLineup: ILineup | null;
	nearestPinLineup: ILineup | null;
	userId: number | null;
	roundId: number | null;
}

export interface IGetMyPickPayload {
	roundId: number;
}

export interface IUpdatePickPayload {
	longestDriveLineup: ILineup;
	nearestPinLineup: ILineup;
	roundId: number;
	margin?: number | null;
}

export interface ISharePickPayload {
	roundId: number;
}

export type TPicksResponse = IApiResponse<{picks: IPickResponse[]}>;
export type TPickResponse = IApiResponse<{pick: IPickResponse}>;
export type TShareResponse = IApiResponse<IShareImage>;

export interface IPinpointApiProvider {
	getMyPick: (payload: IGetMyPickPayload) => Promise<AxiosResponse<TPickResponse>>;
	getListOfMyPicks: () => Promise<AxiosResponse<TPicksResponse>>;
	updatePick: (payload: IUpdatePickPayload) => Promise<AxiosResponse<TPickResponse>>;
	share: (payload: ISharePickPayload) => Promise<AxiosResponse<TShareResponse>>;
}

@injectable()
export class PinpointApiProvider implements IPinpointApiProvider {
	constructor(@inject(Bindings.ApiHTTPClient) private _http: IHttpClientService) {}

	getMyPick = ({roundId}: IGetMyPickPayload) =>
		this._http.get<TPickResponse>(`pinpoint/pick/${roundId}`);

	getListOfMyPicks = () => this._http.get<TPicksResponse>("pinpoint/picks");

	updatePick = (params: IUpdatePickPayload) =>
		this._http.post<TPickResponse>("pinpoint/pick", params);

	share = (params: ISharePickPayload) =>
		this._http.get<TShareResponse>(`pinpoint/pick/share`, params);
}
